import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {
  DEFAULT_VISIT_PLANS_COLUMN_WIDTHS,
  VISIT_PLANS_TABLE_ROW_HEIGHT,
  VISIT_PLANS_TABLE_UNIQUE_ID
} from "../../../constants/visit-plans-table-column-widths.constant";
import {SortType} from "../../../../commons/types/sort.type";

require('./scheduling-project-visit-plans-table.scss');
@Component({
  standalone: false,
  selector: 'app-scheduling-project-visit-plans-table',
  templateUrl: './scheduling-project-visit-plans-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulingProjectVisitPlansTableComponent {

  @Input() visitPlans: VisitPlanModel[] = [];
  @Input() isLoading: boolean;
  @Input() sortType: { name: string, type: SortType };

  @Output() goToVisitPlan = new EventEmitter<VisitPlanModel>();
  @Output() visitPlanActions = new EventEmitter<{ visitPlan: VisitPlanModel, event: Event }>();
  @Output() fetchNext = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<string>();

  public readonly tableUniqueId: string = VISIT_PLANS_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = DEFAULT_VISIT_PLANS_COLUMN_WIDTHS;
  public readonly rowHeight: number = VISIT_PLANS_TABLE_ROW_HEIGHT;
  public readonly asceDescIconsMap: { [key: string]: string } = {
    asc: 'sort-asc',
    desc: 'sort-desc'
  };

}
